import { motion, useReducedMotion } from 'framer-motion';

export const Reveal = ({ children, delay = 0, y = 24, className = '' }) => {
  const shouldReduceMotion = useReducedMotion();
  
  return (
    <motion.div
      initial={{ opacity: 0, y: shouldReduceMotion ? 0 : y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-60px' }}
      transition={{ duration: shouldReduceMotion ? 0.4 : 0.8, delay, ease: [0.7, 0, 0.2, 1] }}
      className={className}
    >
      {children}
    </motion.div>
  );
};

export default Reveal;
